module.exports = require("./crossfilter").crossfilter;



//////////////////
// WEBPACK FOOTER
// /Users/remi/Documents/metabase/metabase-0.28.1/node_modules/crossfilter/index.js
// module id = 207
// module chunks = 7